import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PageSlider } from './page-slider';

@NgModule({
  declarations: [
    PageSlider,
  ],
  imports: [
    IonicPageModule.forChild(PageSlider),
  ],
  exports: [
    PageSlider
  ]
})
export class PageSliderModule {}



// WEBPACK FOOTER //
// ./src/pages/page-slider/page-slider.module.ts